import React from 'react'
import ReactDOM from 'react-dom'
import reportWebVitals from './reportWebVitals'
import 'react-notifications-component/dist/theme.css'
import 'semantic-ui-css/semantic.min.css'
import 'bootstrap/dist/css/bootstrap-grid.min.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css'
import './index.css'
import 'react-quill/dist/quill.snow.css';
import { Form } from 'semantic-ui-react'
import App from './App'
import { AppDropdown } from './components/AppDropdown'

if (Form.Dropdown) {
    Form.Dropdown.defaultProps = {
        ...Form.Dropdown.defaultProps,
        control: AppDropdown,
    }
}

ReactDOM.render(<App />, document.getElementById('root'))

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
